export const QualificationDetailSortEnum = {
    EMPLOYEE: "employee",
    EMPLOYEE_NAME: "employee_name",
    EMPLOYEE_NAME_ASC: "employee_name",
    EMPLOYEE_NAME_DESC: "-employee_name",
    EDUCATOR: "educator",
    EDUCATOR_ASC: "name",
    EDUCATOR_DESC: "-name",
    WEBSITE_URL: "website_url",
    WEBSITE_URL_ASC: "website_url",
    WEBSITE_URL_DESC: "-website_url",
    VALID_AT: "valid_at",
    VALID_AT_ASC: "valid_at",
    VALID_AT_DESC: "-valid_at",
    EXPIRES_AT: "expires_at",
    EXPIRES_AT_ASC: "expires_at",
    EXPIRES_AT_DESC: "-expires_at",
    EDUCATOR_NAME: "educator_name",
    EDUCATOR_NAME_ASC: "educator_name",
    EDUCATOR_NAME_DESC: "-educator_name",
};
